import { InjectionToken } from '@angular/core';
import { DeckingBoardsAccessoriesComponent } from '../pages/configurators-2d/decking-boards/accessories/accessories.component';
import { DeckingBoardsConfigurationComponent } from '../pages/configurators-2d/decking-boards/decking-boards-configuration/decking-boards-configuration.component';
import { DeckingBoardsEnvironmentComponent } from '../pages/configurators-2d/decking-boards/environment/environment.component';
import { DeckingBoardsFinishesComponent } from '../pages/configurators-2d/decking-boards/finishes/finishes.component';
import { DeckingBoardsSummaryComponent } from '../pages/configurators-2d/decking-boards/summary/summary.component';
import { DeckingBoardsService } from '../services/configurators-2d/applications/decking-boards.service';

export const DB_ENVIRONMENT = new InjectionToken(typeof DeckingBoardsEnvironmentComponent);
export const DB_CONFIGURATION = new InjectionToken(typeof DeckingBoardsConfigurationComponent);
export const DB_FINISHES = new InjectionToken(typeof DeckingBoardsFinishesComponent);
export const DB_ACCESSORIES = new InjectionToken(typeof DeckingBoardsAccessoriesComponent);
export const DB_SUMMARY = new InjectionToken(typeof DeckingBoardsSummaryComponent);

export const DB_SERVICE = new InjectionToken(typeof DeckingBoardsService);

export const deckingBoardsProviders = [
  {
    provide: DB_SERVICE,
    useClass: DeckingBoardsService,
  },
  {
    provide: DB_ENVIRONMENT,
    useClass: DeckingBoardsEnvironmentComponent,
  },
  {
    provide: DB_CONFIGURATION,
    useClass: DeckingBoardsConfigurationComponent,
  },
  {
    provide: DB_FINISHES,
    useClass: DeckingBoardsFinishesComponent,
  },
  {
    provide: DB_ACCESSORIES,
    useClass: DeckingBoardsAccessoriesComponent,
  },
  {
    provide: DB_SUMMARY,
    useClass: DeckingBoardsSummaryComponent,
  },
];
